import { checkPbxNameCollisionApi } from "@/react/features/smp/pbx/pbxApi";
import { PBX_COLLISIONS } from "@/react/features/smp/pbx/constants";
import { customMemoize } from "@/react/custom-memoize/customMemoize";

// Memoize the name check API result so that next onBlur events won't call for
// already known results; Cache will expire after 5 minutes
const memoizedCollisionCheck = await customMemoize(
  (pbxName) => checkPbxNameCollisionApi(pbxName),
  { maxAge: 300000 }
);

export const checkNameCollision = async (pbxName, ctx) => {
  if (ctx.options.parent.pbxId) {
    return true;
  }
  const { status } = await memoizedCollisionCheck(pbxName);
  if (status !== PBX_COLLISIONS.NONE) {
    return ctx.createError({
      path: ctx.options.key,
      params: { index: ctx.options.index },
      message:
        status === PBX_COLLISIONS.WORK_ORDER_PBX_COLLISION
          ? "Name previously attempted (work order collision)"
          : "Name already exists",
    });
  }
  return true;
};
